var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content flex flex-center"},[_c('div',{class:{'error': _vm.state === 'error'}},[_vm._v(_vm._s(_vm.flash))])])])}
var staticRenderFns = []

export { render, staticRenderFns }